module.exports = __webpack_public_path__ + "img/img43.bfeb2592.png";